import { render, staticRenderFns } from "./CustomVModel.vue?vue&type=template&id=e39d5a3a&"
import script from "./CustomVModel.vue?vue&type=script&lang=ts&"
export * from "./CustomVModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports